module.exports = __webpack_public_path__ + "public/img/zwsxt.e886fe98.png";